export default {
	all: 'Tümü',
	favorite: 'Favori ',

	'edit-fav-list': 'Favori listeyi düzenle',

	'total-without-vat': 'KDV Hariç toplam',
	'total-net': 'Net toplam',
	paid: 'Ödenen',
	unpaid: 'Ödenmeyen',
	alert: 'Uyarı',
	'alert-message': 'varsa , bu hesap için tahsis edilen fiyatlarla değiştirilecektir',
	'search-products': 'Ürünleri ara',
	'main-items': 'Ana ürünler',
	'invoice-details': 'Fatura detayları',
	extra: 'Ekstra',
	'all-favorites': 'Tüm favoriler',
	'did-not-add-any-items-yet': 'Henüz gerekli ürün eklenmedi.',
	'choose-item-to-add': 'Miktarı ayarlayarak eklemek için bir ürün seçin.',

}